import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Global query options
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors
        if (error?.status >= 400 && error?.status < 500) {
          return false;
        }
        // Retry up to 3 times
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      // Global mutation options
      retry: false,
      onError: (error: any) => {
        console.error('Mutation error:', error);
      },
    },
  },
});

// Query keys for consistent caching
export const queryKeys = {
  // Auth
  auth: ['auth'] as const,
  user: ['user'] as const,
  userProfile: (id: string) => ['user', 'profile', id] as const,
  
  // Themes
  themes: ['themes'] as const,
  theme: (id: string) => ['theme', id] as const,
  currentTheme: ['theme', 'current'] as const,
  
  // Projects
  projects: ['projects'] as const,
  project: (id: string) => ['project', id] as const,
  projectComponents: (projectId: string) => ['project', projectId, 'components'] as const,
  
  // Reports
  reports: ['reports'] as const,
  report: (id: string) => ['report', id] as const,
  reportData: (reportId: string) => ['report', reportId, 'data'] as const,
  
  // Settings
  settings: ['settings'] as const,
  userSettings: (userId: string) => ['settings', 'user', userId] as const,
  
  // Notifications
  notifications: ['notifications'] as const,
  unreadNotifications: ['notifications', 'unread'] as const,
  
  // Search
  search: (query: string) => ['search', query] as const,
  
  // Dashboard
  dashboard: ['dashboard'] as const,
  dashboardStats: ['dashboard', 'stats'] as const,
  dashboardCharts: ['dashboard', 'charts'] as const,
} as const;


